import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BruteForceGameAssets} from "../BruteForceGameAssets";
import {BruteForce} from "../BruteForce";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {gsap} from "gsap";
import {IWinRatioInfo} from "../BruteForceWinConfigs";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {BruteForceSound} from "../sound/BruteForceSound";

export class BruteForceTotalWinCountupView extends PIXI.Container implements StageLayer {

    private _countUp: BasicBitmapCountUp;
    public isWinShowing: boolean;

    constructor() {
        super();
        this.name = "BruteForceTotalWinCountupView";
        this.init();
    }

    private init() {
        this._countUp = new BasicBitmapCountUp({
            fontName: BruteForceGameAssets.BITMAP_BIGWIN_FONT,
            fontSize: 50,
            tint: 0xffffff
        }, 480, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 340);
        this._countUp.stopAt(0);
        this._countUp.visible = false;
        this.visible = false;
        this.addChild(this._countUp);

        this.isWinShowing = false;
        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {

    }

    public onResize() {

    }

    public show(winRatioConfig: IWinRatioInfo): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let countUpSound: string = "";

        switch (winRatioConfig.type) {
            case "tiny":
                countUpSound = BruteForceSound.WIN_TINY;
                break;
            case "small":
                countUpSound = BruteForceSound.WIN_SMALL;
                break;
            case "medium":
                countUpSound = BruteForceSound.WIN_MIDIEUM;
                break;
            case "large":
                countUpSound = BruteForceSound.WIN_LARGE;
                break;
            default:
                break;
        }

        tl.add(() => {
            this._countUp.visible = true;
            this._countUp.stopAt(0);
            this._countUp.scale.set(0.5, 0.5);
            this._countUp.alpha = 1;
            this.alpha = 0;
            this.visible = true;
            this.isWinShowing = true;
        });
        tl.add([
            gsap.to(this, {alpha: 1}),
            gsap.to(this._countUp.scale, {x: 1, y: 1, ease: "sine.in"}),
            () => {
                if (!BelowStakeWinRestriction.isWinBelowStake()) {
                    BruteForceSound.playTrack(countUpSound, 1);
                }
            },
            this._countUp.getCountAnimation(0, BruteForce.model.gameData.totalSpinWinnings, winRatioConfig.duration)
        ]);
        tl.to(this, {duration: 0.1});
        return tl;
    }

    public hide(): gsap.core.Timeline {
        const hideTL: gsap.core.Timeline = gsap.timeline();
        hideTL.to(this, {alpha: 0, delay: 0.2});
        hideTL.add(() => {
            this._countUp.visible = false;
            this.visible = false;
            this.isWinShowing = false;
        }, ">");
        return hideTL;
    }

    public showCountUpPostWincap(): void {
        this._countUp.visible = true;
        this._countUp.stopAt(0);
        this._countUp.scale.set(1, 1);
        this._countUp.alpha = 1;
        this.alpha = 1;
        this.visible = true;
        this.isWinShowing = true;
        this._countUp.getCountAnimation(0, BruteForce.model.gameData.accumulatedRoundWin, 0);
    }


}